import axios from 'axios';
import { createAsyncThunk, createSlice, isPending, isRejected } from '@reduxjs/toolkit';
import { API_ROUTES } from '@/config/api-routes';
import { normalizeQstatDashboardAnalytics, } from '../model/qstat-dashboard.model';
import { serializeAxiosError, resolveAsyncThunkErrorMessage } from './reducer.utils';
const apiBase = API_ROUTES.qstat.dashboard;
const initialState = {
    loading: false,
    errorMessage: null,
    analytics: null,
    lastUpdated: null,
};
export const getQstatDashboardAnalytics = createAsyncThunk('qstatDashboard/analytics', async () => axios.get(apiBase), { serializeError: serializeAxiosError });
export const qstatDashboardSlice = createSlice({
    name: 'qstatDashboard',
    initialState: initialState,
    reducers: {
        clearQstatDashboard(state) {
            state.analytics = null;
            state.errorMessage = null;
            state.lastUpdated = null;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getQstatDashboardAnalytics.fulfilled, (state, action) => {
            state.loading = false;
            state.analytics = normalizeQstatDashboardAnalytics(action.payload.data);
            state.lastUpdated = new Date().toISOString();
        })
            .addMatcher(isPending(getQstatDashboardAnalytics), (state) => {
            state.loading = true;
            state.errorMessage = null;
        })
            .addMatcher(isRejected(getQstatDashboardAnalytics), (state, action) => {
            state.loading = false;
            state.errorMessage = resolveAsyncThunkErrorMessage(action.error);
        });
    },
});
export const { clearQstatDashboard } = qstatDashboardSlice.actions;
export default qstatDashboardSlice.reducer;
